import { render, staticRenderFns } from "./DetalleMant.vue?vue&type=template&id=548c6feb"
import script from "./DetalleMant.vue?vue&type=script&lang=js"
export * from "./DetalleMant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports